import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import CallAdaptiveButton from 'flow/components/CallAdaptiveButton';
import {
    selectOriginDTOSubtype,
    selectVisitorDisplayName,
} from 'flow/selectors/TicketsSelectors';
import { TicketKey } from 'flow/types/EntityKeys';
import { originContactIsPhoneNumber } from 'flow/utils/ticket-channel-utils';

interface Props {
    ticketKey: TicketKey;
}

const TicketHeaderPhoneButton = ({ ticketKey }: Props) => {
    const displayName = useAppSelector((state) =>
        selectVisitorDisplayName(state, ticketKey),
    );
    const originDtoSubtype = useAppSelector((state) =>
        selectOriginDTOSubtype(state, ticketKey),
    );

    if (!originContactIsPhoneNumber(originDtoSubtype) || !displayName)
        return null;

    // The corners come from the button itself, not from an `overflow-hidden`
    // wrapper: that clipped the focus ring, which draws outside the button.
    return (
        <div className="[&_button]:rounded-lg">
            <CallAdaptiveButton
                phoneNumber={displayName}
                size="medium"
                inactiveBgColor="bg-gray-200"
            />
        </div>
    );
};

export default React.memo(TicketHeaderPhoneButton);
